<template>
  <fragment v-if="createPhoneViewModel">
    <b-field>
      <b-switch v-model="createPhoneViewModel.PhoneEnabled" @input="onPhoneEnabledChange($event)">
        {{ $t("CampaignEdit.Phones.PhoneEnabled") }}
      </b-switch>
    </b-field>
    <div v-if="createPhoneViewModel.PhoneEnabled">
      <div class="maskyoo-phone">
        <div class="maskyoo-phone-label">
          <label class="label">{{ $t("CampaignEdit.Phones.Phone") }}</label>
        </div>
        <div class="maskyoo-phone-field">
          <b-field>
            <b-input v-model="createPhoneViewModel.MaskyooPhone" disabled @input="onInputChange"></b-input>
          </b-field>
          <div class="important-info">{{ $t("CampaignEdit.Phones.PhoneImportantInformation") }}</div>
        </div>
        <div class="maskyoo-phone-btn">
          <b-button size="is-small" @click="renewPhone">{{ $t("CampaignEdit.Phones.ChangePhone") }}</b-button>
        </div>
      </div>
      <div class="channel-edit-group channel-edit-group-fields">
        <div class="field-w">
          <b-field :label="$t('CampaignEdit.Phones.RedirectPhone')">
            <b-input type="textarea" rows="2" v-model="createPhoneViewModel.RedirectPhoneForUi" :placeholder="$t('CampaignEdit.Phones.RedirectPhone')"
                  :disabled="createPhoneViewModel.UseClientPhone && !createPhoneViewModel.RedirectPhone"
                  @input="onRedirectPhoneForUiChange"></b-input>
          </b-field>
        </div>
        <div class="field-w">
          <b-field :label="$t('CampaignEdit.Phones.PhoneForSms')">
            <b-input v-model="createPhoneViewModel.PhoneForSms" :placeholder="$t('CampaignEdit.Phones.PhonePlaceholder')" @input="onInputChange"></b-input>
          </b-field>
        </div>
        <div class="field-w">
          <b-field :label="$t('CampaignEdit.Phones.Expose')">
            <b-select expanded :placeholder="$t('CampaignEdit.Phones.Expose')" v-model="createPhoneViewModel.Expose" @input="onInputChange">
                <option :value="2">
                  {{ $t("CampaignEdit.Phones.ExposeEnum.Caller") }}
                </option>
                <option :value="1">
                  {{ $t("CampaignEdit.Phones.ExposeEnum.Maskyoo") }}
                </option>
              </b-select>
          </b-field>
        </div>
        <div class="field-w">
          <b-field :label="$t('CampaignEdit.Phones.RecordOption')">
            <b-select expanded :placeholder="$t('CampaignEdit.Phones.RecordOption')" v-model="createPhoneViewModel.RecordOption" @input="onInputChange">
                <option :value="1">
                  {{ $t("CampaignEdit.Phones.RecordOptionEnum.Caller") }}
                </option>
                <option :value="2">
                  {{ $t("CampaignEdit.Phones.RecordOptionEnum.Callie") }}
                </option>
                <option :value="3">
                  {{ $t("CampaignEdit.Phones.RecordOptionEnum.CallerAndCallie") }}
                </option>
                <option :value="4">
                  {{ $t("Phones.EditPopup.RecordOption.DoNotRecordCalls")}}
                </option>
              </b-select>
          </b-field>
        </div>
        <div class="field-w">
          <b-field :label="$t('CampaignEdit.Phones.DialOption')">
            <b-select expanded :placeholder="$t('CampaignEdit.Phones.RecordOption')" v-model="createPhoneViewModel.DialOption" @input="onInputChange">
                <option :value="1">
                  {{ $t("CampaignEdit.Phones.DialOptionEnum.Parralel") }}
                </option>
                <option :value="2">
                  {{ $t("CampaignEdit.Phones.DialOptionEnum.Hunt") }}
                </option>
                <option :value="3">
                  {{ $t("Phones.EditPopup.DialOption.IVR") }}
                </option>
              </b-select>
          </b-field>
        </div>
        <div class="field-w">
          <b-field>
            <template #label>
              {{ $t('Phones.EditPopup.GreetingIn') }}
              <b-tooltip type="is-dark" :label="$t('Phones.EditPopup.GreetingInTooltip')" multilined>
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
              </b-tooltip>
              <a href="#" class="upload-audio-file" @click="uploadAudioFile">{{ $t('Phones.EditPopup.UploadAudioFile.Label') }}</a>
            </template>
            <b-dropdown :value="createPhoneViewModel.GreetingIn" scrollable :max-height="300" aria-role="list" :disabled="!prompts.length" @change="onGreetingInPromptChange">
              <template #trigger>
                <b-button>
                  <span class="dropdown-trigger-value">{{ createPhoneViewModel.GreetingIn || $t("Phones.EditPopup.GreetingInPlaceholder") }}</span>
                  <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
                </b-button>
              </template>
              <b-dropdown-item custom aria-role="listitem">
                <b-input v-model="greetingInPromptsSearch" :placeholder="$t('Search')" expanded />
              </b-dropdown-item>
              <b-dropdown-item v-for="prompt in greetingInPromptsFiltered" :key="prompt.Value" :value="prompt.Value" aria-role="listitem">
                <span>{{ prompt.Text }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </b-field>
        </div>
        <div class="field-w">
          <b-field>
            <template #label>
              {{ $t('Phones.EditPopup.RingbackTone') }}
              <b-tooltip type="is-dark" :label="$t('Phones.EditPopup.RingbackToneTooltip')" multilined>
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
              </b-tooltip>
              <a href="#" class="upload-audio-file" @click="uploadAudioFile">{{ $t('Phones.EditPopup.UploadAudioFile.Label') }}</a>
            </template>
            <b-dropdown :value="createPhoneViewModel.RingbackTone" scrollable :max-height="300" aria-role="list" :disabled="!promptsRingbackTone.length" @change="onRingbackTonePromptChange">
              <template #trigger>
                <b-button>
                  <span class="dropdown-trigger-value">{{ createPhoneViewModel.RingbackTone || $t("Phones.EditPopup.GreetingInPlaceholder") }}</span>
                  <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
                </b-button>
              </template>
              <b-dropdown-item custom aria-role="listitem">
                <b-input v-model="ringbackTonePromptsSearch" :placeholder="$t('Search')" expanded />
              </b-dropdown-item>
              <b-dropdown-item v-for="prompt in ringbackTonePromptsFiltered" :key="prompt.Value" :value="prompt.Value" aria-role="listitem">
                <span>{{ prompt.Text }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </b-field>
        </div>
        <div class="field-w">
          <b-field>
            <template #label>
              {{ $t('Phones.EditPopup.GreetingOut') }}
              <b-tooltip type="is-dark" :label="$t('Phones.EditPopup.GreetingOutTooltip')" multilined>
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
              </b-tooltip>
              <a href="#" class="upload-audio-file" @click="uploadAudioFile">{{ $t('Phones.EditPopup.UploadAudioFile.Label') }}</a>
            </template>
            <b-dropdown :value="createPhoneViewModel.GreetingOut" scrollable :max-height="300" aria-role="list" :disabled="!prompts.length" @change="onGreetingOutPromptChange">
              <template #trigger>
                <b-button>
                  <span class="dropdown-trigger-value">{{ createPhoneViewModel.GreetingOut || $t("Phones.EditPopup.GreetingInPlaceholder") }}</span>
                  <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
                </b-button>
              </template>
              <b-dropdown-item custom aria-role="listitem">
                <b-input v-model="greetingOutPromptsSearch" :placeholder="$t('Search')" expanded />
              </b-dropdown-item>
              <b-dropdown-item v-for="prompt in greetingOutPromptsFiltered" :key="prompt.Value" :value="prompt.Value" aria-role="listitem">
                <span>{{ prompt.Text }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </b-field>
        </div>
        <div class="field-w">
          <b-field :label="$t('Phones.EditPopup.AnswerTime')">
            <b-select expanded :placeholder="$t('Phones.EditPopup.AnswerTime')" v-model="createPhoneViewModel.AnswerTime" @input="onInputChange">
              <option v-for="answerTimeOption in answerTimeOptions"
                    :value="answerTimeOption"
                    :key="answerTimeOption">
                {{ answerTimeOption }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="field-w">
          <b-field>
            <b-checkbox v-model="createPhoneViewModel.CallCenter" @input="onInputChange">{{ $t("Phones.EditPopup.CallCenter") }}</b-checkbox>
          </b-field>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script lang="ts">
import Fragment from "vue-fragment";
import { Component, Vue, Watch } from "vue-property-decorator";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/he";
import { Action, Getter } from "vuex-class";
import i18n from "@/i18n";
import { SelectListItem } from "@/models/MultiselectItem";
import { Result } from "@/models/Result";
import { Campaign, CampaignEditViewModel } from "@/models/campaigns/Campaign";
import { CampaignEditPageKind } from "@/models/campaigns/CampaignEditPageKind";
import { AddPhoneErrorType } from "@/models/phones/AddPhoneErrorType";
import { CreatePhoneViewModel } from "@/models/phones/CreatePhoneViewModel";
import CampaignService from "@/services/CampaignService";
import HelperService from "@/services/HelperService";
import CampaignsApiService from "@/services/api/CampaignsApiService";
import PhonesApiService from "@/services/api/PhonesApiService";
import DefaultClientPhoneDlg from "./DefaultClientPhoneDlg.vue";
import IconBase from "../IconBase.vue";
import IconCalendar from "../icons/IconCalendar.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";
import UploadAudio from "../Phones/UploadAudio.vue";

Vue.use(Fragment.Plugin);
const namespace = "campaignsModule";

@Component({
  components: {
    DatePicker,
    IconBase,
    IconCalendar,
    IconCaretDown,
  },
})
export default class TabPhones extends Vue {

  //#region Vuex getters and actions

  @Getter("campaignEditViewModel", { namespace }) campaignEditViewModel!: CampaignEditViewModel;
  @Getter("createPhoneViewModel", { namespace }) createPhoneViewModel!: CreatePhoneViewModel;
  @Action("setCreatePhoneViewModel", { namespace }) setCreatePhoneViewModel!: (createPhoneViewModel: CreatePhoneViewModel) => Promise<void>;

  //#endregion Vuex getters and actions


  //#region Properties

  greetingInPromptsSearch = "";
  greetingOutPromptsSearch = "";
  ringbackTonePromptsSearch = "";
  prompts: SelectListItem[] = [];
  promptsRingbackTone: SelectListItem[] = [];

  CampaignEditPageKind = CampaignEditPageKind;

  //#endregion Properties


  //#region Watchers

  @Watch("campaignEditViewModel", { immediate: true })
  onCampaignEditViewModelChange(newCampaignEditViewModel: CampaignEditViewModel, oldCampaignEditViewModel: CampaignEditViewModel): void {
    if (!newCampaignEditViewModel) {
      return;
    }
    let loader = this.$loading.show();
    CampaignsApiService.getCampaignEditPhonesData(newCampaignEditViewModel.Campaign.ID).then((data: CreatePhoneViewModel) => {
      this.setCreatePhoneViewModel(data);
      this.createPhoneViewModel.IsChannelEdit = this.pageKind === CampaignEditPageKind.Edit;
      this.createPhoneViewModel.ShowPhoneFlag = data.PhoneEnabled;
      loader.hide();
      if (this.$route.hash === "#phones-channel" && !this.createPhoneViewModel.PhoneEnabled) {
        this.onPhoneEnabledChange(true);
      }
    });
    this.getPrompts();
  }

  //#endregion Watchers


  //#region Getters

  get answerTimeOptions(): number[] {
    return [...Array(88).keys()].map((i: number) => (i + 3) * 2);
  }

  get campaign(): Campaign {
    return this.campaignEditViewModel?.Campaign;
  }

  get greetingInPromptsFiltered(): SelectListItem[] {
    if (this.prompts) {
      return this.prompts.filter((i: SelectListItem) => i.Text.toLowerCase().indexOf(this.greetingInPromptsSearch.toLowerCase()) >= 0);
    } else {
      return [];
    }
  }

  get greetingOutPromptsFiltered(): SelectListItem[] {
    if (this.prompts) {
      return this.prompts.filter((i: SelectListItem) => i.Text.toLowerCase().indexOf(this.greetingOutPromptsSearch.toLowerCase()) >= 0);
    } else {
      return [];
    }
  }

  get ringbackTonePromptsFiltered(): SelectListItem[] {
    if (this.prompts) {
      return this.promptsRingbackTone.filter((i: SelectListItem) => i.Text.toLowerCase().indexOf(this.ringbackTonePromptsSearch.toLowerCase()) >= 0);
    } else {
      return [];
    }
  }

  get pageKind(): CampaignEditPageKind {
    return CampaignService.getCampaignEditPageKind(this.$route.path);
  }

  //#endregion Getters


  //#region Handlers

  onDropdownActiveChange(show: boolean) {
    HelperService.onDropdownActiveChange(show);
  }

  onGreetingInPromptChange(prompt: string): void {
    this.createPhoneViewModel.GreetingIn = prompt;
    this.setCreatePhoneViewModel(this.createPhoneViewModel);
  }

  onGreetingOutPromptChange(prompt: string): void {
    this.createPhoneViewModel.GreetingOut = prompt;
    this.setCreatePhoneViewModel(this.createPhoneViewModel);
  }

  onInputChange(): void {
    this.setCreatePhoneViewModel(this.createPhoneViewModel);
  }

  onRingbackTonePromptChange(prompt: string): void {
    this.createPhoneViewModel.RingbackTone = prompt;
    this.setCreatePhoneViewModel(this.createPhoneViewModel);
  }

  onPhoneEnabledChange(phoneEnabled: boolean) {
    this.createPhoneViewModel.ClientId = this.campaign.ClientId;
    this.createPhoneViewModel.PhoneChannelId = this.campaign.ID;
    this.createPhoneViewModel.PhoneState = phoneEnabled;
    this.createPhoneViewModel.TenantId = this.campaign.TenantId;
    let loader = this.$loading.show();
    CampaignsApiService.togglePhoneState(this.createPhoneViewModel).then((result: Result) => {
      if (result.Success) {
        this.createPhoneViewModel.PhoneEnabled = phoneEnabled;
        this.createPhoneViewModel.MaskyooPhone = result.Data as string;
        if (this.$route.hash === "#phones-channel" && this.createPhoneViewModel.PhoneEnabled) {
          HelperService.showSuccess(i18n.t("CampaignEdit.Phones.AddPhoneSuccess").toString());
        }
      } else {
        this.createPhoneViewModel.PhoneEnabled = !phoneEnabled;
        if (result.Data as AddPhoneErrorType === AddPhoneErrorType.RedirectPhoneRequired) {
          const modal = this.$buefy.modal.open({
            parent: this,
            component: DefaultClientPhoneDlg,
            hasModalCard: true,
            trapFocus: true,
            props: {
              "clentTitle": this.createPhoneViewModel.ClientTitle
            },
            events: {
              'update': (phone: string) => {
                const loader = this.$loading.show();
                CampaignsApiService.checkPhones(phone).then((result: Result) => {
                  if (result.Success) {
                    this.createPhoneViewModel.RedirectPhone = this.createPhoneViewModel.RedirectPhoneForUi = phone;
                    this.renewPhone();
                    modal.close();
                  } else {
                    HelperService.showError(result.Message);
                  }
                  loader.hide();
                });
              }
            }
          });
        } else {
          HelperService.showError(result.Message);
        }
      }
    }).finally(() => {
      loader.hide();
    });
  }

  onRedirectPhoneForUiChange() {
    this.createPhoneViewModel.RedirectPhone = this.createPhoneViewModel.RedirectPhoneForUi;
    this.onInputChange();
  }

  renewPhone() {
    HelperService.showConfirmDialog(
      i18n.t("CampaignEdit.Phones.ChangePhoneDialog.Title").toString(),
      i18n.t("CampaignEdit.Phones.ChangePhoneDialog.Text").toString(),
      i18n.t("Yes").toString(),
      i18n.t("No").toString(),
      () => {
        let loader = this.$loading.show();
        CampaignsApiService.renewPhone(this.createPhoneViewModel).then((result: Result) => {
          if (result.Success) {
            this.createPhoneViewModel.MaskyooPhone = result.Data as string;
            this.createPhoneViewModel.PhoneEnabled = true;
          } else {
            HelperService.showError(result.Message);
          }
        }).finally(() => {
          loader.hide();
        });
      }
    );
  }

  //#endregion Handlers


  //#region Private methods

  getPrompts(): void {
    PhonesApiService.getPhonesPrompts(this.campaign.TenantId, this.campaign.ClientId, false)
        .then((prompts: SelectListItem[]) => {
          this.prompts = prompts;
        });
    PhonesApiService.getPhonesPrompts(this.campaign.TenantId, this.campaign.ClientId, true)
        .then((prompts: SelectListItem[]) => {
          this.promptsRingbackTone = prompts;
        });
  }

  uploadAudioFile(e: Event): void {
    e.preventDefault();
    this.$buefy.modal.open({
      parent: this,
      component: UploadAudio,
      hasModalCard: true,
      trapFocus: true,
      props: {
        "tenantId": this.campaign.TenantId,
        "clientId": this.campaign.ClientId
      },
      events: {
        'update': () => {
          this.getPrompts();
        }
      }
    })
  }

  //#endregion Private methods
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.channel-edit-group {
  margin-bottom: 25px;

  &.channel-edit-group-field {
    max-width: 894px;

    .channel-edit-field {
      margin-bottom: 1rem;
    }

    .label {
      font-size: 17px;
      margin: 0;
      display: inline;
    }
  }

  &.channel-edit-group-fields {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -12px;

    .field-w {
      padding: 0 12px 25px;
      flex-grow: 1;
      width: 50%;

      @media (max-width: 991px) {
        width: 100%;
      }

      .dropdown {
        width: 100%;

        .dropdown-item-with-icon {
          display: flex;

          .icon-w {
            display: flex;
            margin-inline-end: 0.5rem;
            min-width: 22px;

            img {
              max-height: 22px;
              min-width: 22px;
              width: 22px;
            }
          }
        }

        .dropdown-trigger {

          .button {
            width: 100%;
          }
        }
      }

      .upload-audio-file {
        margin-inline-start: 1rem;
      }
    }
  }
}

.maskyoo-phone {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 1rem;
  
  .maskyoo-phone-btn {

  }

  .maskyoo-phone-field {
    width: 50%;

    @media (max-width: $bp_md) {
      width: 100%;
    }

    .important-info {
      color: #f00;
      font-size: .8rem;
    }
  }

  .maskyoo-phone-label {

    @media (max-width: $bp_md) {
      margin-bottom: .5rem;
    }
  }
}

</style>
